'use strict';
var React = require('react');
var Products = require('../../utils/Products');
var FundingYourProductStore = require('../../stores/FundingYourProductStore');

function GetProductHeaderState() {
  return {
      downsizerContributionSwitch: FundingYourProductStore.getDownsizerContributionSwitch()
  };
}

var ProductHeader = React.createClass({
  getInitialState: function () {
    return GetProductHeaderState();
  },

  componentDidMount: function () {
    FundingYourProductStore.addChangeListener(this._onChange);
  },

  componentWillUnmount: function () {
    FundingYourProductStore.removeChangeListener(this._onChange);
  },

  _onChange: function () {
    this.setState(GetProductHeaderState());
  },

    render: function () {
        var productId = this.props.product.value;
        var content = (this.props.content) ? this.props.content : {};
        var downsizerContributionKillSwitchEnabled = this.state.downsizerContributionSwitch.killSwitch;
        return (           
        <div className="form-step" id="ProductHeader">
            <nav className="navbar-sub-title navbar navbar-sub">
              <div className="container">
                <div className="pull-left">
                  <h2>{this.props.product.label}</h2>
                </div>
              </div>
            </nav>
            <nav className="navbar navbar-sub-disclosure">
              <div className="container">
                <span className="navbar-sub-image">
                  <a href={content.pdsLink} target="_blank"><img src="Images/icon-pdf.png" width="32" alt="pdf link per product" /></a>
                </span>
                <span>
                {(productId) ? <p className="context-copy" dangerouslySetInnerHTML={{__html: content.productHeaderCopy}}></p> : null}
                {(productId && Products.isSuper(productId) && !downsizerContributionKillSwitchEnabled) ? <div><br /><p className="context-copy" dangerouslySetInnerHTML={{__html: content.downsizerContributionNotice}}></p></div> : null}
                </span>
              </div>
            </nav>
        </div>
		);
    }
});

module.exports = ProductHeader;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/ProductHeader.jsx